
<div class="row">
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-3"></div>
      <div class="col-sm-6">
        <form [formGroup]="trainingForm">
          <input type="hidden" formControlName="id" />
          <div class="form-group">
            <label class="lbl">{{preInstallation.languageLbl}}</label>
            <kendo-dropdownlist class="kendoInput" name="languageCode"
                                formControlName="languageCode"
                                [data]="getLanguages"
                                [textField]="'languageCode'"
                                [valueField]="'languageCode'"
                                [ngModel]="{languageCode:selectedLanguage}" (selectionChange)="lanaguageChange($event)" [ngClass]="{'borderRed':preInstallation.isLanguageCodeEmpty && preInstallation.isSubmitted}" (blur)="validatePreInstallationForm()">
            </kendo-dropdownlist>
          </div>
          <div class="form-group">
            <!--[for]="terms"-->
            <kendo-label class="k-radio-label"
                         text="Input Method &nbsp; &nbsp;   "></kendo-label>
            <input type="radio"
                   name="preInstallationInputMethod"
                   value="TextEditor"
                   #textEditor [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="preInstallationInputMethod"
                   kendoRadioButton />
            <label class="k-label" [for]="textEditor">Text Editor &nbsp;</label>

            <input type="radio"
                   name="preInstallationInputMethod"
                   value="FileUpload"
                   #fileUpload [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="preInstallationInputMethod"
                   kendoRadioButton />
            <label class="k-label" [for]="fileUpload">File Upload</label>
          </div>
          <div class="form-group" *ngIf="preInstallationInputMethod==='TextEditor'">
            <label class="lbl">{{preInstallation.descriptionLbl}}</label>
            <!--<textarea kendoTextArea class="kendoInput textArea-height"
    formControlName="description" [disabled]="!enableText" [ngClass]="{'borderRed':preInstallation.isDescriptionEmpty && preInstallation.isSubmitted}" (blur)="validatePreInstallationForm()"></textarea>-->
            <kendo-editor class="kendoInput" formControlName="description"
                          [ngClass]="{'borderRed':preInstallation.isDescriptionEmpty && preInstallation.isSubmitted}" (blur)="validatePreInstallationForm()"></kendo-editor>
          </div>
          <div class="form-group" *ngIf="preInstallationInputMethod==='FileUpload'">
            <div class="kendoInput">
              <app-upload [multiple]="false" (fileSelect)="preInstallationSelected($event)"
                          [uploadFolderPath]="'TempDocs\\PreInstallation'"
                          [ngClass]="{'borderRed':preInstallation.isEmptyPreInstallationUrlPath && preInstallation.isSubmitted}"
                          (uploadSuccess)="preInstallationUploadSuccess($event)"
                          [fileRestrictions]="fileRestrictions"></app-upload>
            </div>
            <!--<label class="lblCls">
              {{preInstallationUrlPath}}
            </label>-->

          </div>
          <div class="form-group" *ngIf="preInstallationInputMethod==='FileUpload'">
            <div id="pdfIframediv" class="row myIframe" *ngIf="preInstallationUrl">
              <iframe class="PdfReport"
                      [src]="preInstallationUrl"
                      type="application/pdf"></iframe>
            </div>
          </div>
        </form>
        <br />
        <div class="align-center">
          <div class="btn-group" role="group">
            <button kendoButton class=" m-3 btn k-button"
                    (click)="resetForm()">
              Cancel
            </button> &nbsp;&nbsp;
            <button kendoButton class=" m-3 btn btn-success"
                    (click)="savePreInstallationDescription()">
              Save<!--<kendo-loader style="color:blue"></kendo-loader>-->
            </button>
            <!--*ngIf="saveInProcess"-->
          </div>
        </div>
      </div>
      <div class="col-sm-3"></div>
    </div>

  </div>
</div>
